import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import { auth } from "../../../../firebase.init";
import HeroSection from "../../../Common/HeroSection/HeroSection";
import SocialLogin from "./SocialLogin";
import "./Login.css";

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);

  const handleLoginSubmit = (event) => {
    const email = event.target.email.value;
    const password = event.target.password.value;
    signInWithEmailAndPassword(email, password);

    event.preventDefault();
  };
  const from = location.state?.from?.pathname || "/";
  if (user) {
    navigate(from, { replace: true });
  }
  return (
    <div>
      <HeroSection name={"Login"}></HeroSection>
      <form className="w-50 m-auto mt-5 " onSubmit={handleLoginSubmit}>
        <section>
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">
              Email address
            </label>
            <input
              required
              name="email"
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
            <div id="emailHelp" className="form-text">
              We'll never share your email with anyone else.
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="exampleInputPassword1" className="form-label">
              Password
            </label>
            <input
              required
              name="password"
              type="password"
              className="form-control"
              id="exampleInputPassword1"
            />
          </div>
          <div className="mb-3 form-check">
            <input
              required
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
            />

            <label className="form-check-label" htmlFor="exampleCheck1">
              Check me out
            </label>
            <span className="d-block text-info">
              {" "}
              {loading && "loading..."} {error && error.message}
            </span>
          </div>
          <span className="d-block text-warning"></span>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </section>
        <br />
        <h4>Don't have account? <Link to='/signup'>Sign Up</Link></h4>

        <hr />

        <p className="h3">Login With Others</p>
        <br />

        <SocialLogin></SocialLogin>
      </form>
    </div>
  );
};

export default Login;
